import { SVGProps } from 'react';

function EditIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.8879 3.10164L4.14616 10.2375C3.8916 10.5085 3.64525 11.0423 3.59598 11.4118L3.29215 14.0724C3.1854 15.0331 3.87517 15.6901 4.82772 15.5258L7.47186 15.0742C7.84139 15.0085 8.35872 14.7375 8.61328 14.4583L15.355 7.32242C16.5211 6.09067 17.0466 4.68649 15.2318 2.97026C13.4253 1.27045 12.054 1.8699 10.8879 3.10164Z"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.76172 4.29297C10.1148 6.55938 11.9542 8.29203 14.2371 8.52196"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.46484 18.2129H17.2458"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default EditIcon;
